<script lang="ts">
	import type { ButtonSize } from '../button/types';
	import IconLabel from '../iconlabel/IconLabel.svelte';

	interface Props {
		size?: ButtonSize;
		text?: string;
		hasIcon?: boolean;
		class?: string;
	}

	const {
		size = 'md',
		text = '',
		hasIcon = false,
		class: classes,
	}: Props = $props();

</script>

<div
	class={[`bg-neutral-soft leading-none text-transparent select-none btn btn-${size} cursor-default w-fit`, classes]}
>
	<IconLabel icon={hasIcon ? 'add' : undefined} label={text} labelClasses="px-1" />
</div>
